// const popupcon = document.querySelector(".popup-container");
const popupVideo = document.querySelector(".videoCon");
const popupTrigger = document.querySelector(".popupTrigger");
const video = document.querySelector(".video");
const closeIcon = document.querySelector(".close-video");

if (popupVideo) {
	popupTrigger.addEventListener("click", () => {
		popupVideo.classList.add("active");
		video.classList.add("active");
	});

	closeIcon.addEventListener("click", () => {
		popupVideo.classList.remove("active");
		video.classList.remove("active");
	});
}
